import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// layouts
import FormField from "layouts/ecommerce/products/edit-product/components/FormField";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// redux
import { useSelector, useDispatch } from "react-redux";
import * as actions from "redux/actions/song";

// SongDto: {id, userId, title, artist, url, thumbnailUrl}. url is a plain
// link to externally-hosted audio — this backend has no way to upload audio
// files at all (its only upload endpoint accepts images only).
const emptyForm = {
  id: 0,
  title: "",
  artist: "",
  url: "",
};

const SongForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state?.editData;
  const song = useSelector((state) => state.song);

  const [form, setForm] = React.useState(editData ? { ...emptyForm, ...editData } : emptyForm);

  React.useEffect(() => {
    if (song.songSaved) navigate(`/upload/song`);
  }, [song, navigate])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!form.title) {
      alert("Title is required.");
      return;
    }
    if (!form.url) {
      alert("A song URL is required.");
      return;
    }
    if (editData) dispatch(actions.editSong(form));
    else dispatch(actions.addSong(form));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container>
        <Grid item xs={12} md={12} xl={12}>
          <MDBox py={3} pr={1}>
            <Card sx={{ width: "100%" }}>
              <MDBox display="flex">
                <MDBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="4rem"
                  height="4rem"
                  variant="gradient"
                  bgColor="primary"
                  color="white"
                  shadow="md"
                  borderRadius="xl"
                  ml={3}
                  mt={-2}
                >
                  <Icon fontSize="medium" color="inherit">
                    add
                  </Icon>
                </MDBox>
                <MDBox>
                  <MDTypography variant="h6" sx={{ mt: 2, mb: 1, ml: 2 }}>
                    {editData ? "Edit Song" : "Add Song"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <Grid container>
                <Grid item xs={12}>
                  <Card>
                    <MDBox p={3}>
                      <MDBox mt={1}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={6}>
                            <FormField
                              type="text"
                              label="Title"
                              name="title"
                              value={form.title}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormField
                              type="text"
                              label="Artist"
                              name="artist"
                              value={form.artist}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                     </MDBox>
                      <MDBox mt={2}>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <FormField
                              type="url"
                              label="Song URL"
                              name="url"
                              value={form.url}
                              onChange={handleChange}
                              placeholder="https://..."
                            />
                          </Grid>
                        </Grid>
                      </MDBox>
                      <MDBox mt={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <MDBox display="flex" justifyContent="end">
                              <MDButton color="primary" onClick={!song.savingSong ? handleSubmit : undefined}>
                                {song.savingSong ? "Submitting..." : "Submit"}
                              </MDButton>
                            </MDBox>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </Card>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={4} xl={4}></Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default SongForm;
